<!--MaxDiff-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{ `${index + 1}、` }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>MaxDiff</p>
          </div>

          <div style="display: flex; align-items: center; margin-left: 10px">
            <div class="select-box">
              <p style="font-size: 14px; margin-right: 5px; color: #409eff">
                任务数设置：
              </p>
              <!-- <el-select v-model="tasksNum" placeholder="请选择" size="mini" style="
		            border: 1px solid #dcdde0;
		            border-radius: 3px;
		            width: 100px;
		          ">
								<el-option v-for="score in styleColumns" :key="score.id" :label="score.label"
									:value="score.id">
								</el-option>
							</el-select> -->
              <el-select
                v-model="tasksNum"
                placeholder="请选择"
                size="mini"
                style="
                  border: 1px solid #dcdde0;
                  border-radius: 3px;
                  width: 70px;
                "
                @change="handleUpdateQuestion"
              >
                <el-option
                  v-for="score in styleColumns"
                  :key="score.id"
                  :label="score.label"
                  :value="score.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select-box">
              <p
                style="
                  font-size: 14px;
                  margin-right: 5px;
                  margin-left: 5px;
                  color: #409eff;
                "
              >
                任务属性数设置：
              </p>
              <!-- <el-select v-model="attributesNum" placeholder="请选择" size="mini" style="
		            border: 1px solid #dcdde0;
		            border-radius: 3px;
		            width: 100px;
		          ">
								<el-option v-for="score in scoreColumns" :key="score.id" :label="score.label"
									:value="score.id">
								</el-option>
							</el-select> -->
              <el-select
                v-model="attributesNum"
                placeholder="请选择"
                size="mini"
                style="
                  border: 1px solid #dcdde0;
                  border-radius: 3px;
                  width: 70px;
                "
                @change="handleUpdateQuestion"
              >
                <el-option
                  v-for="score in scoreColumns"
                  :key="score.id"
                  :label="score.label"
                  :value="score.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请输入题目说明"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
      <div class="options">
        <div class="option-table">
          <div class="option-table-header">
            <div class="option-table-cell">
              <input class="option-input" disabled />
            </div>
            <div class="option-table-cell">
              <input
                v-model="headerBest"
                class="option-input"
                @focus="focusIndex = 'headerBest'"
                @blur="handleHeaderUpdate('headerBest')"
              />
              <img
                v-if="focusIndex !== 'headerBest'"
                class="edit"
                src="https://ossfastmake.mustke.com/qrCode/tupian/1761027416820.png"
              />
            </div>
            <div class="option-table-cell">
              <input
                v-model="headerWorst"
                class="option-input"
                @focus="focusIndex = 'headerWorst'"
                @blur="handleHeaderUpdate('headerWorst')"
              />
              <img
                v-if="focusIndex !== 'headerWorst'"
                class="edit"
                src="https://ossfastmake.mustke.com/qrCode/tupian/1761027416820.png"
              />
            </div>
          </div>
          <div class="option-table-body">
            <div
              v-for="(option, index) in list"
              :key="index"
              class="option-table-row"
            >
              <div class="option-table-cell">
                <div class="option-table-cell-flex">
                  <div class="operation">
                    <img
                      v-if="list.length > 3"
                      @click="delItem(index)"
                      class="del1"
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1761026299128.png"
                    />
                    <img
                      v-else
                      class="del1"
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1761027044995.png"
                    />
                    <input
                      v-model.trim="option.context"
                      class="option-input"
                      @focus="focusIndex = index"
                      @blur="onInputBlur(index)"
                    />
                    <img
                      v-if="focusIndex !== index"
                      class="edit"
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1761027416820.png"
                    />
                  </div>

                  <label class="radio-wrap">
                    <div class="radio-box">
                      <div class="dot"></div>
                    </div>
                  </label>

                  <label class="radio-wrap">
                    <div class="radio-box">
                      <div class="dot"></div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="add-view">
        <div class="add-batch" style="color: #ffffff">
          <el-checkbox
            label="必选题"
            v-model="isMust"
            :true-label="1"
            :false-label="0"
            class="custom-checkbox"
            @change="handleUpdateQuestion"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            mode=""
            style="width: 13px; height: 13px"
          />
          <p>添加属性 {{ list.length + "/50" }}</p>
        </div>
        <div @click="batchAddOptions" class="add-batch">批量添加</div>
      </div>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <PopupInput
      :showDialog="showpopup"
      @close="showpopup = false"
      @confirm="bitchConfirm"
      :aContent="''"
      :type="1"
    >
    </PopupInput>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  components: {
    PopupInput,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [], // 选项列表
      dataObj: {}, // 存储当前问题的数据
      isMust: false, // 是否必选
      showpopup: false, // 批量添加选项的弹框
      uploadIndex: 0,
      images: [], // 题目图片列表
      caseProblem: "", // 题目说明
      focusIndex: "", // 当前焦点的索引
      headerBest: "", // 任务的最佳值
      headerWorst: "", // 任务的最差值
      tasksNum: 6, // 任务数设置
      attributesNum: 3, // 任务属性数设置
      styleColumns: [
        {
          id: 6,
          label: "6",
        },
        {
          id: 7,
          label: "7",
        },
        {
          id: 8,
          label: "8",
        },
        {
          id: 9,
          label: "9",
        },
      ],
      scoreColumns: [
        {
          id: 3,
          label: "3",
        },
        {
          id: 4,
          label: "4",
        },
        {
          id: 5,
          label: "5",
        },
      ],
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("uuid", this.uuid);
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        })
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    addOption() {
      if (this.list.length < 50) {
        const newIndex = this.list.length + 1;

        this.list.push({
          id: "",
          context: `属性${newIndex}`,
          isChoose: false,
          img_path: [],
          is_fill: 0,
          fill_prompt: "",
          newDate: true,
        });

        this.handleUpdateQuestion();
      } else {
        uni.showToast({
          title: "最多只能添加50个属性",
          icon: "none",
        });
      }
    },
    batchAddOptions() {
      this.showpopup = true;
      const savedHeaderBest = this.headerBest;
      const savedHeaderWorst = this.headerWorst;

      this.showpopup = true;

      this.headerBest = savedHeaderBest;
      this.headerWorst = savedHeaderWorst;
    },
    bitchConfirm(e) {
      this.showpopup = false;
      const count = e.split("\n").filter((item) => item.trim() !== "").length;

      if (count > 50 - this.list.length) {
        uni.showToast({
          title: "最多只能添加50个属性",
          icon: "none",
        });
        return;
      }

      const list = e
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item, index) => {
          const lastOption = this.list[this.list.length - 1];
          const nextIndex = lastOption
            ? parseInt(lastOption.context.replace(/\D/g, "")) + 1 + index
            : index + 1;

          return {
            id: "",
            context: item || `属性${nextIndex}`,
            isChoose: false,
            img_path: [],
            is_fill: 0,
            fill_prompt: "",
            newDate: true,
          };
        });

      this.list = this.list.concat(list);
      this.handleUpdateQuestion();
    },
    delItem(index) {
      this.list.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem = this.caseProblem;

      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item) => ({
          id: item.id || "",
          context: item.context || `属性${this.list.indexOf(item) + 1}`,
          is_fill: item.is_fill || 0,
        })),
        tasksNum: this.tasksNum,
        attributesNum: this.attributesNum,
        percentageTitle: `${this.headerBest},${this.headerWorst}`,
      });

      console.log("Updated chooseList:", this.dataObj.chooseList);

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        uni.showToast({
          title: "请输入题目",
          icon: "none",
        });
        return;
      }

      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "请选择一个选项" : this.caseProblem;

      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          item.text = item.text === "" ? `选项${index + 1}` : item.text;
          return item;
        }),
        tasksNum: this.tasksNum,
        attributesNum: this.attributesNum,
        percentageTitle: `${this.headerBest},${this.headerWorst}`,
      });

      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    handleClick() {},
    handleHeaderUpdate() {
      this.handleUpdateQuestion();
    },
    onInputBlur() {
      this.handleUpdateQuestion();
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("dataObj 变化了", newVal, oldVal);
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.list = JSON.parse(newVal.chooseList).list.map((item) => {
          item.is_fill = item.is_fill === 1;
          return item;
        });
        this.isMust = newVal.isMust === 1;
        this.images = JSON.parse(newVal.caseProblemImg);

        if (newVal.chooseList) {
          const chooseList = JSON.parse(newVal.chooseList);
          const percentageTitle = chooseList.percentageTitle || "";
          const titles = percentageTitle.split(",");
          this.headerBest = titles[0] || "";
          this.headerWorst = titles[1] || "";
          this.tasksNum = chooseList.tasksNum;
          this.attributesNum = chooseList.attributesNum;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}

.textarea-box textarea {
  color: #4c4a56;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}

.options .option-table .edit {
  width: 17px;
  height: 17px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
}

.options .option-table .option-table-header {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #f5f7fa;
  min-height: 40px;
  border-top: 1px solid #bbbbbb;
  border-left: 1px solid #bbbbbb;
}

.options .option-table .option-table-header .option-table-cell {
  border-right: 1px solid #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.options .option-table .option-table-header .option-table-cell input {
  padding: 0 30px 0 10px;
  width: 100%;
  height: 100%;
}

.options .option-table .option-table-body {
  border-bottom: 1px solid #bbbbbb;
  margin-bottom: 10px;
}

.options .option-table .option-table-body .option-table-cell {
  min-height: 40px;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex {
  min-height: 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid #bbbbbb;
  border-left: 1px solid #bbbbbb;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .operation {
  display: flex;
  border-right: 1px solid #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .operation
  input {
  padding: 0 30px 0 10px;
  width: 100%;
  height: 100%;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .operation
  .del1 {
  width: 14.5px;
  height: 12.5px;
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 5;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .radio-wrap {
  border-right: 1px solid #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.select-box {
  display: flex;
  align-items: center;
}

.select-box p {
  margin-right: 5px;
  white-space: nowrap;
  letter-spacing: -1px;
}

.radio-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.radio-box {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditMaxDiff.vue